export default "__VITE_ASSET__Bc0TlZO0__"